import $ from "cash-dom";

export default class TabsModule {

    static name = 'tabs'

    constructor(node) {

        const $tabsRow = $(node).children('.tabs__row');
        const $tabsContent = $(node).children('.tabs__content');

        $tabsRow.on('click', '.tabs__tab', function(e) {

            const $tab = $(this);
            const $content = $tabsContent.children('.tabs__inner:nth-child('+ ($tab.index()+1) +')');

            //active classes
            $tab
                .add($content)
                .addClass('active')
                .siblings()
                .removeClass('active');
        });
    }
}